import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AbstractComponent } from '@haleo-frontend/utils';

@Component({
    selector: 'app-fullpage-popover',
    templateUrl: 'fullpage-popover.modal.html',
    styleUrls: ['fullpage-popover.modal.scss']
})
export class FullpagePopoverModal extends AbstractComponent {

    @Input() title: string;
    @Input() description: string;
    @Input() icon: string;
    @Input() hideCloseButton: boolean;
    @Input() buttons: Array<{ handler: any, label: string, type: string, color: string }>;

    constructor(private modalController: ModalController) {
        super();
    }

    close() {
        this.modalController.dismiss();
    }
}
